import { useFormContext } from '@kanda-libs/ks-component-ts';
import { useCallback, useMemo } from 'react';
import {
  FinanceCalculatorFormValues,
  useFinanceCalculatorContext,
} from '../../context';

export interface CalculateBorrowAmountButtonHook {
  onClick: () => void;
  className: string;
  isLoading: boolean;
}

export default function useCalculateBorrowAmountButton(): CalculateBorrowAmountButtonHook {
  const { isLoading, stored, onBorrowAmountClick } =
    useFinanceCalculatorContext();
  const { unregister } = useFormContext<FinanceCalculatorFormValues>();

  const { type } = stored;

  const active = useMemo(() => type === 'borrowAmount', [type]);

  const className = useMemo(
    () =>
      [
        'px-3 py-2 border rounded-tr-lg text-14-22-em',
        active
          ? 'border-purple-500 bg-purple-50 text-purple-500'
          : 'border-neutral-300 bg-neutral-000 text-neutral-700',
      ].join(' '),
    [active],
  );

  const onClick = useCallback(() => {
    unregister('amountToBorrow');
    onBorrowAmountClick();
  }, [unregister, onBorrowAmountClick]);

  return {
    onClick,
    className,
    isLoading,
  };
}
